<template>
    <el-row>
        <el-col >
          <div class="grid-content">
            <div class="bpinpai-list"><h3>品牌活动:</h3><img src="@/assets/images/lxnh-2026.png" alt="领袖年会"><img src="@/assets/images/mulan-logo.png" alt="全球木兰论坛"><img src="@/assets/images/21xing-logo.png" alt="未来之星"></div>
            <bbottom></bbottom>
          </div>
        </el-col>
    </el-row>
</template>
<script>
  import bbottom from "@/components/public/bbottom.vue"
  export default{
      name:'Bottom',
      data () {
        return {
          msg: 'success'
        }
      },
      //组件引入
      components: {
        bbottom
      },
  }
</script>

<style scoped>

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }
.grid-content{
    width:100%;
    background-color:#bd0c16;
  
    color:#fff;
    min-width: 1200px;
    }

  .bpinpai-list {
    text-align: center;
    padding:30px 0px 10px;
    width: 680px;
    margin: 0 auto;
  }
  .bpinpai-list h3{
      display:inline-block;
      font-size:16px;
      line-height:50px;
      margin:0px 10px 0px;
      padding:0px!important;
      font-weight:normal;
  }
    .bpinpai-list img{
        display:inline-block;
        vertical-align:middle

    }
 
</style>



// WEBPACK FOOTER //
// src/components/public/Bottom.vue